import React from 'react'
import { Divider, Row, Col, Form, Input, Select, Button, Skeleton, message, Checkbox } from 'antd'
import * as deepObject from 'deep-object-diff'
import { FormComponent } from '../../../BaseComponent'
import { PartnerKeyTypeArray } from '../../../../interfaces/IIntegration'
import IShelter from '../../../../interfaces/IShelter'
import { SearchRequest } from '../../../../services/api/interfaces/ApiRequest'
import { PartnerAuthRequest } from '../../../../services/integration/interfaces/ApiRequest'

type IntegrationAuthProps = {
  authUuid?: string | null,
  error: any | null
  
  loading: boolean,
  contentLoading?: boolean
  history: any,

  shelters: IShelter[] | null

  loadShelters: (args: SearchRequest) => Promise<any>,
  
  authPartner: (args: PartnerAuthRequest) => Promise<any>,
  updateDefinition: (args: PartnerAuthRequest) => Promise<any>,
  closeModal: any,
  selectedItem:any
}

export default class IntegrationAuth extends FormComponent<IntegrationAuthProps> {

  static defaultProps = {
    contentLoading: true
  }

  state = {
    saving: false,
    loaded: false,

    partnerKey: this.props.selectedItem?.partner_key ? this.props.selectedItem?.partner_key : '',
    shelterUuid: this.props.selectedItem?.shelter?.uuid ? this.props.selectedItem?.shelter?.uuid : '',
    defaultValue: {
      "characteristicType": "ADOPTION_PATH",
      "path": "",
      "type": "",
      "condition": "",
      "value": "",
      "active": true,
      "global": false,
      "priority": 0
    },
    selectedCharacteristicType:this.props.selectedItem?.characteristicType ? this.props.selectedItem?.characteristicType : '',
    characteristicTypeList : [
          "ADOPTION_PATH",
          "ALLOW_ADOPT_BUTTON",
          "BONDED_PAIR",
          "DOG_COMPATIBLE",
          "DOG_SELECTIVE",
          "NO_DOGS",
          "CAT_COMPATIBLE",
          "CAT_SELECTIVE",
          "NO_CATS",
          "YOUNG_KID_COMPATIBLE",
          "OLDER_KID_COMPATIBLE",
          "NO_KIDS",
          "NO_SMALL_ANIMALS",
          "HIGH_ENERGY",
          "MEDIUM_ENERGY",
          "LOW_ENERGY",
          "HOUSETRAINED",
          "SPECIAL_BEHAVIORAL_NEEDS",
          "SPECIAL_MEDICAL_NEEDS",
          "FIV_POSITIVE",
          "FELV_POSITIVE",
          "HEARTWORM_POSITIVE",
          "DECLAWED",
          "SPECIAL_DIET",
          "FOSTER_ELIGIBLE",
          "WORKING_CAT",
          "INDOOR_ONLY",
          "INDOOR_OUTDOOR",
          "NO_APARTMENTS",
          "FENCED_YARD_REQUIRED",
          "LONG_TERM_RESIDENT",
          "NO_LIVESTOCK",
          "UNKNOWN_WITH_DOGS",
          "UNKNOWN_WITH_CATS",
          "UNKNOWN_WITH_KIDS",
          "TALKATIVE",
          "SERVICE_DOG_MATERIAL",
          "PLAYFUL",
          "LOVES_TO_BE_BRUSHED",
          "LOVES_THE_WATER",
          "LOVES_FOOD_TREATS",
          "LOVES_CAR_RIDES",
          "LEASH_TRAINED",
          "KNOW_TRICKS",
          "INDEPENDENT",
          "CUDDLER",
          "QUIET_HOME",
      ].map(item => ({
        label: item,
        value: item
    })),
    selectedtype:this.props.selectedItem?.type ? this.props.selectedItem?.type : '',
    typeList : [
      {
        label:"MATCH",
        value:"MATCH"
      },
      {
        label:"RETRIEVE",
        value:"RETRIEVE"
      }
    ],

  }

  componentDidMount() {
    const { shelters, loadShelters } = this.props

    if (!shelters) {
      loadShelters({
        search: {
          deleted: false,
          organization_branches: {
            with: {
              deleted: false
            }
          }
        },
        options: {
          // limit: 99999
        }
      })
    }
  }

  componentDidUpdate(prevProps: IntegrationAuthProps, prevState: any) {
    const wasLoading = prevProps.loading && !this.props.loading
    let newState = Object.assign({}, this.state)
    
    if (!this.props.contentLoading && !newState.loaded) {
      newState.loaded = true
    }

    if (this.state.loaded) {
      if (this.state.saving && wasLoading) {
        newState.saving = false

        if (this.props.error) {
          message.error(`Could not make authentication with partner. Reason ${this.props.error}`)
        }
      }
    }

    const hasChanged = Object.keys(deepObject.diff(this.state, newState)).length > 0
    if (hasChanged) {
      this.setState(newState)
    }
  }

  async handleSave(values: any){
   
    
    this.setState({
      saving: true
    })
    let response = null;
    if(this.props.selectedItem?.uuid){
      const payload: any ={
        "definition_uuid" : this.props.selectedItem?.uuid,
        "shelter_uuid": this.state.shelterUuid,
        "partner_key": this.state.partnerKey,
        "characteristicType": this.state.selectedCharacteristicType,
        "path": values.path,
        "type": this.state.selectedtype,
        "condition": values.condition.toString(),
        "value": values.value,
        "active": values.active,
        "global": values.global,
        "priority": values.priority
    }
    response = await this.props.updateDefinition(payload)
    }else{
      const payload: any ={
          "shelter_uuid": this.state.shelterUuid,
          "partner_key": this.state.partnerKey,
          "characteristicType": this.state.selectedCharacteristicType,
          "path": values.path,
          "type": this.state.selectedtype,
          "condition": values.condition.toString(),
          "value": values.value,
          "active": values.active,
          "global": values.global,
          "priority": values.priority
      }
      response = await this.props.authPartner(payload)
    }


    
    
    this.setState({
      saving: false
    })
    
    if(!(response as any)?.data?.error){
      this.props.closeModal();
    }else{
      message.error(`Could not save. Reason: ${JSON.stringify((response as any)?.data?.error)}`)
    }
  }


  renderPartners = () => {
    return (
      <Select
        placeholder="Partner"
        allowClear={true}
        disabled={this.props.selectedItem}
        options={PartnerKeyTypeArray.map(partnerKey => {
          return {
            label: partnerKey,
            value: partnerKey
          }
        })}
        style={{
          width: "100%"
        }}
        defaultValue={this.props.selectedItem?.partner_key}
        onChange={(partnerKey: string) => this.setState({ partnerKey })}
      />
    )
  }

  renderCharacteristics = () => {
    return (
      <Select
        placeholder="Characteristics type"
        allowClear={true}
        options={this.state.characteristicTypeList}
        style={{
          width: "100%"
        }}
        defaultValue={this.props.selectedItem?.characteristicType}
        onChange={(selectedCharacteristicType: string) => this.setState({ selectedCharacteristicType })}
      />
    )
  }

  renderType = () => {
    return (
      <Select
        placeholder="Type"
        allowClear={true}
        options={this.state.typeList}
        style={{
          width: "100%"
        }}
        defaultValue={this.props.selectedItem?.type}
        onChange={(selectedtype: string) => this.setState({ selectedtype })}
      />
    )
  }

  renderShelters = () => {
    const { shelters } = this.props

    return (
      <Select
        placeholder="Shelter"
        allowClear={true}
        showSearch={true}
        disabled={this.props.selectedItem}
        options={shelters?.map(shelter => {
          return {
            label: shelter.name,
            value: shelter.uuid
          }
        })}
        style={{
          width: "100%"
        }}
        defaultValue={this.props.selectedItem?.shelter?.uuid}
        filterOption={(input, option) => {
          if (!option?.label || typeof option.label !== 'string') return false

          return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }}
        onChange={(shelterUuid: string) => this.setState({ shelterUuid })}
      />
    )
  }


  mountFields = () => {

    return (
      <Row gutter={24}>
        <Col span={12} key={`credential-field-description`}>
          <Form.Item
            label="Value"
            name={"value"}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Condition"
            name={"condition"}
          >
            <Input defaultValue="$value == 'cow'"/>
          </Form.Item>
          <Form.Item
            label="Active"
            valuePropName="checked"
            name={"active"}
          >
            <Checkbox defaultChecked={false}/>
          </Form.Item>

          
        </Col>
        <Col span={12} key={`credential-field-description2`}>
          <Form.Item
            label="Path"
            name={ "path"}
          >
            <Input defaultValue="$.Status.Value.123"/>
          </Form.Item>
          <Form.Item
            label="Priority"
            name={"priority"}
          >
            <Input type="number" defaultValue={10}/>
          </Form.Item>
          <Form.Item
            label="Global"
            valuePropName="checked"
            name={"global"}
          >
            <Checkbox disabled={this.props.selectedItem} defaultChecked={false}/>
          </Form.Item>
        </Col>
      </Row>
    )
  }

  render() {
    const { loaded, saving } = this.state

    if (!loaded) {
      return <Skeleton />
    }

    return (
      <Form
        name="integration_auth"
        layout="vertical"
        onFinish={this.handleSave.bind(this)}
        initialValues={this.props.selectedItem ? this.props.selectedItem : this.state.defaultValue}
        style={{
          marginTop: 30
        }}
      >
        <Row gutter={24}>
          <Col span={12}>
            {this.renderPartners()}
          </Col>

          <Col span={12}>
            {this.renderShelters()}
          </Col>

        </Row>

        <Divider />

        <Row gutter={24}>
          <Col span={12}>
          {this.renderCharacteristics()}
          </Col>

          <Col span={12}>
            {this.renderType()}
          </Col>

        </Row>

        <Divider />

        {
          this.mountFields()
        }

        <Form.Item style={{marginTop: 32}}>
          <Button type="primary" htmlType="submit" size="middle" loading={saving}>
            Save
          </Button>
        </Form.Item>
      </Form>
    )
  }
}
